import { SeoKeyDefaultMap } from '../../types/seo/SeoOverride'

const seoDefaultKeyMap: SeoKeyDefaultMap = {
    socialTitle: 'title'
    // googleTitle: 'title'
}

export default seoDefaultKeyMap
